import classes from "./Footer.module.css";
import appleMini from "./../../assets/images/apple_mini.png";
import androidMini from "./../../assets/images/android_mini.jpg";
import information from "./../../assets/images/information_project.png";
import {
  androidAppLink,
  informationLink,
  informationLinkEN,
  iosAppLink,
} from "../../../SMARTCITY/hardCodeData/DATA";
import { useContext } from "react";
import LanguageContext from "../../hooks/language-context";
import { useHistory } from "react-router-dom";
import SvgTerms from "../../assets/icons/Terms";

const Footer = () => {
  const getYear = () => {
    const d = new Date();
    return d.getFullYear();
  };
  const languageCtx = useContext(LanguageContext);
  const history = useHistory();
  return (
    <div className={classes.footer}>
      <p className={classes.copyright}>&copy;{getYear()} DotSoft</p>
      <div>
        <SvgTerms
          width={27}
          style={{ cursor: "pointer", paddingInline: "2px" }}
          onClick={() => history.push("/terms-of-use")}
        />
        <img
          src={information}
          alt={"information-application"}
          onClick={() =>
            window.open(
              languageCtx.languageCode === "en"
                ? informationLinkEN
                : informationLink
            )
          }
        />
        <img
          src={appleMini}
          alt={"apple-application"}
          onClick={() => window.open(iosAppLink)}
        />
        <img
          src={androidMini}
          alt={"android-application"}
          onClick={() => window.open(androidAppLink)}
        />
      </div>
      {/* <div
        id="uWayContainer"
        style={{
          position: "absolute",
          bottom: "40px",
          right: "10px",
          width: "80px",
          height: "80px",
          // background: "red",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      ></div> */}
    </div>
  );
};

export default Footer;
